<div class="d-flex flex-row">
  <ngx-json-viewer [json]="displayObject" [expanded]="isObjectExpanded">
  </ngx-json-viewer>
</div>